const actions = {
    Baseline_Start_REQUEST: 'Baseline_Start_REQUEST',
    Baseline_End_REQUEST: 'Baseline_End_REQUEST',
    Post_Start_REQUEST: 'Post_Start_REQUEST',
    Post_End_REQUEST: 'Post_End_REQUEST',
    Electricity_Price_REQUEST: 'Electricity_Price_REQUEST',
    Gas_Price_REQUEST: 'Gas_Price_REQUEST',

    BaselineStartREQUEST: (data) => ({
        type: actions.Baseline_Start_REQUEST,
        payload: {data},
    }),
    BaselineEndREQUEST: (data) => ({
        type: actions.Baseline_End_REQUEST,
        payload: {data},
    }),
    PostStartREQUEST: (data) => ({
        type: actions.Post_Start_REQUEST,
        payload: {data},
    }),
    PostEndREQUEST: (data) => ({
        type: actions.Post_End_REQUEST,
        payload: {data},
    }),
    ElectricityPriceREQUEST: (data) => ({
        type: actions.Electricity_Price_REQUEST,
        payload: {data},
    }),
    GasPriceREQUEST: (data) => ({
        type: actions.Gas_Price_REQUEST,
        payload: {data},
    }),

};
export default actions;
